<template>
  <UContent
    class="bank-card"
    :style="{
      '--watermark-url': `url('/svg/${theme}/watermark.svg')`
    }"
  >
    <template #content>
      <h3>{{ header }}</h3>
      <div>
        <UInput
          v-model="cardNumber"
          type="number"
          label="Card"
          placeholder="Master card: **** 3322"
          :disabled="true"
          @update:modelValue="onInput"
        />

        <UInput
          class="mt-1"
          style="width: 140px"
          placeholder="Add new card +"
          :disabled="true"
        />
      </div>
      <div>Banks</div>
      <div class="bank-label">
        {{ descriptions }}
      </div>
      <UInput
        style="width: 140px"
        placeholder="Add new bank +"
        :disabled="true"
      />
    </template>
  </UContent>
</template>

<script setup>
import { computed, ref } from "vue";
import { useStore } from "vuex";

const emit = defineEmits(["cardNumberChange"]);

const store = useStore();
const cardNumber = ref(null);
const theme = computed(() => (store.getters.isLightTheme ? "light" : "dark"));

defineProps({
  header: {
    type: String,
    default: "Deposit form"
  },
  descriptions: {
    type: String,
    default: "Add a banks to deposit from anywhere in the world"
  }
});


const onInput = (value) => {
  cardNumber.value = value;
  emit("cardNumberChange", value);
};
</script>

<style lang="scss" scoped>
.bank-card {
  position: relative;
  overflow: hidden;
  background: var(--color-05);

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    top: -40px;
    bottom: -40px;
    background-image: var(--watermark-url);
    background-repeat: repeat;
    transform: rotate(-15deg);
    opacity: 0.08;
    pointer-events: none;
    z-index: 1;
  }
}
.bank-label {
  margin-bottom: -8px;
}
</style>
